import axios from "axios";
import { getApiBase } from "../apiBase";

function baseUrl(apiUrl) {
  return apiUrl || getApiBase();
}

export async function fetchInterconnects({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/interconnects`, {
    headers: getAuthHeaders?.(),
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchInterconnectPartnerOptions({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/interconnects/partner-options`, {
    headers: getAuthHeaders?.(),
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchProjectInterconnectFields(projectId, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/projects/${projectId}/interconnect-fields`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function saveProjectInterconnectFields(projectId, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.put(
    `${baseUrl(apiUrl)}/projects/${projectId}/interconnect-fields`,
    body,
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export async function fetchInterconnect(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/interconnects/${id}`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function createInterconnect(body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/interconnects`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function updateInterconnect(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.patch(`${baseUrl(apiUrl)}/interconnects/${id}`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function setInterconnectLinkedProject(id, linkedProjectId, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.put(
    `${baseUrl(apiUrl)}/interconnects/${id}/projects`,
    { linkedProjectId },
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export async function setInterconnectAssociatedSegments(id, associatedSegmentBases, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.put(
    `${baseUrl(apiUrl)}/interconnects/${id}/associated-segments`,
    { associatedSegmentBases },
    { headers: getAuthHeaders?.() }
  );
  return data;
}

/** @deprecated Use setInterconnectLinkedProject */
export async function setInterconnectProjects(id, projectIds, primaryProjectId, { apiUrl, getAuthHeaders } = {}) {
  return setInterconnectLinkedProject(
    id,
    Array.isArray(projectIds) ? projectIds[0] ?? null : projectIds ?? primaryProjectId ?? null,
    { apiUrl, getAuthHeaders }
  );
}

export async function deleteInterconnect(id, { apiUrl, getAuthHeaders } = {}) {
  await axios.delete(`${baseUrl(apiUrl)}/interconnects/${id}`, {
    headers: getAuthHeaders?.(),
  });
}
